'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
const theme_Typography = require('../../../theme/Typography.cjs.js');
require('react');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TableHeadHeading", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: flex;
    align-items: center;
    color: ${theme_Colors.Colors.TextDefault};
    ${theme_Typography.Typography.SmallPrint2};
  `
});
const TableHeadHeading = (props) => {
  return react.jsx("span", { css: Styles.root }, props.children);
};

exports.TableHeadHeading = TableHeadHeading;
//# sourceMappingURL=TableHeadHeading.cjs.js.map
